import React, { Component } from "react";
import { Title } from "components/misc";
import { Container } from 'design-react-kit';
import { withRouter } from 'react-router-dom';
import { AdminLessonTrainingScheduleForm } from "components/forms/admin/AdminLessonTrainingScheduleForm";


class LessonTrainingScheduleForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
        idLessonTrainingSchedule: parseInt(this.props.match.params.idLessonTrainingSchedule) > 0 ? this.props.match.params.idLessonTrainingSchedule : 0
    }
  }

  render() {

    const { idLessonTrainingSchedule } = this.state

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{(idLessonTrainingSchedule > 0) ? 'Aggiorna Training' : 'Crea Training'}</Title>
            {<AdminLessonTrainingScheduleForm idLessonTrainingSchedule={idLessonTrainingSchedule || 0}/>}
          </Container>
        </section>
      </>
    );
  }

}

export default withRouter(LessonTrainingScheduleForm);
